import { CheckerStatus } from '@/Views/BeforeLogin/FreeTools/AccessibilityChecker/AccessibilityChecker.consts';

export type AccessibilityCheckerStore = {
  selectedIssueCategory: IssuesCategoryType;
  selectedSeverity: SeverityLevel;
  issuesFound?: IssuesFound;
  filteredIssues: Issue[];
  recommendations: Issue[];
  status: CheckerStatus;
  accessibilityScore: number;
  issuesCount: number;
  setAccessibilityData: (data: any) => void;
  setStatus: (status: CheckerStatus) => void;
  selectIssueCategory: (selectedIssue: IssuesCategoryType) => void;
  selectSeverity: (index: number) => void;
  getSelectedSeverityIndex: () => number;
  getAmountOfIssuePerCategory: (issueCategory: IssuesCategoryType) => number;
  getAmountOfIssues: () => number;
  isAuditPassed: () => boolean;
};

export type IssueDetails = {
  selector: string;
  snippet: string;
  lhId: string;
  type: string;
  path: string;
  nodeLabel: string;
};

export type Issue = {
  issue: string;
  title: string;
  description: string;
  score: number;
  details: IssueDetails[];
  name?: string;
};

export type IssueCategory = {
  [key in IssuesCategoryType]?: Issue[];
};

export type IssuesFound = {
  [key in SeverityLevel]?: IssueCategory;
};

export enum SeverityLevel {
  CRITICAL = 'critical',
  MODERATE = 'moderate',
  MINOR = 'minor',
}

export enum IssuesCategoryType {
  COLOR_CONTRAST = 'color_contrast',
  KB_NAVIGATION = 'kb_navigation',
  ARIA_ROLES = 'aria_roles',
  FORM_A11Y = 'form_a11y',
  SCREEN_READER = 'screen_reader',
  MISSING_ALT = 'missing_alt',
  GENERAL = 'general',
}
